import React, { Component } from 'react';
import icons from '../../assets/images/icons_ethic.png';
import IconSet from './IconSet';

class IconSetEthic extends Component {
  render() {
    const { width } = this.props;
    const items = ['rgpd', 'diversite', 'cnil'];
    const sets = { 'size_48': icons};
    let sizes = {};
    if (width === 'xs') {
      sizes.x = 75;
      sizes.y = 40;
    } else {
      sizes.x = 75;
      sizes.y = 40;
    }
    return <IconSet  items={items} size={48} sets={sets} iconWidth={sizes.x} iconHeight={sizes.y} {...this.props} />

  }
}

export default IconSetEthic;



// WEBPACK FOOTER //
// ./src/components/Icon/IconSetEthic.jsx